//export const LOGIN_BASEURL = 'https://er-staging-dashboard-backend2.virtuallythere.in'
export const LOGIN_BASEURL = 'https://er-dashboard-backend.everyring.io'

export const WEBSOCKET_URL = 'https://er-dashboard-backend.everyring.io'
//export const WEBSOCKET_URL = 'https://er-staging-dashboard-backend2.virtuallythere.in'

export const SIP_HOST = "er-01.everyring.io";

export const SNOOP_NUMBER = "102";
export const BARGE_NUMBER = "103";
export const WHISPER_NUMBER = "104";

export const AZURE_CLIENT_ID = "a37e3bbc-df65-42d4-b3a0-c12c4fffbbcd";
export const AZURE_TENANT_ID = "43736b0b-a13c-43a1-a5e2-3bfe4bb05f90";
export const AZURE_REDIRECT_URL = "https://er-dashboard.everyring.io";
// Scope defined in "App -> API Permissions" in Azure portal
export const AZURE_SCOPE = "api://a37e3bbc-df65-42d4-b3a0-c12c4fffbbcd/er-dashboard";
// export const AZURE_SCOPE = "er-dashboard";

